import styled, { css } from 'styled-components';

import { HEX, RGB } from "../../Styles/LegacyColors";
import { commonResets } from "../../Styles/Utils";

// TO DO: Align and extract these to theme. (WP-254)
// TO DO: Extract styles from _commonStyles to packages/styles (WP-255)

export const FormCheckboxWrapper = /*#__PURE__*/styled.label.withConfig({ displayName: "FormCheckboxstyles__FormCheckboxWrapper", componentId: "sc-fejfsp-0" })(["", " & *,&:before,&:after,& *:before,& *:after{", "}width:100%;height:100%;display:block;input[type='checkbox']{width:0;}", ""],
commonResets,





commonResets,










(props) =>
props.autoHeight &&
css(["height:auto;"]));




export const FormCheckboxBox = /*#__PURE__*/styled.div.withConfig({ displayName: "FormCheckboxstyles__FormCheckboxBox", componentId: "sc-fejfsp-1" })(["display:flex;position:relative;border:1px solid ", ";transition:all 0.2s ease;cursor:pointer;min-height:60px;padding:15px 20px 15px 60px;", " ", ":hover &{background:rgba(", ",0.05);}"],


HEX.lightGrey,





(props) =>
props.active &&
css(["border-color:", ";"],
HEX.blue),


/* sc-selector */FormCheckboxWrapper,
RGB.blue);



export const FormCheckboxDot = /*#__PURE__*/styled.div.withConfig({ displayName: "FormCheckboxstyles__FormCheckboxDot", componentId: "sc-fejfsp-2" })(["width:20px;height:20px;border:1px solid ", ";transition:all 0.2s ease;position:absolute;top:50%;margin-top:-10px;left:20px;border-radius:2px;&:after{width:20px;height:20px;transition:all 0.2s ease;top:50%;left:50%;transform:translate3d(-50%,-50%,0);content:' ';position:absolute;z-index:-1;display:block;background:rgba(", ",0.1);border-radius:2px;opacity:0;}", ""],


HEX.lightGrey,


















RGB.blue,




(props) =>
props.active &&
css(["border-color:", ";background:", ";&:after{width:30px;height:30px;opacity:1;}"],
HEX.blue,
HEX.blue));









export const FormCheckboxLabel = /*#__PURE__*/styled.div.withConfig({ displayName: "FormCheckboxstyles__FormCheckboxLabel", componentId: "sc-fejfsp-3" })(["font-size:16px;line-height:1.35;font-weight:300;align-self:center;cursor:pointer;"]);